import { useEffect } from "react";
import { useRouter } from "next/router";
import usePrevious from "utils/react/usePrevious";
import { useCurrentBrandId } from "./currentUserHooks";

export default function useOnBrandChange(onBrandChange: () => void) {
  const router = useRouter();
  const brandId = useCurrentBrandId();
  const prevBrandId = usePrevious(brandId);

  useEffect(() => {
    if (prevBrandId && brandId !== prevBrandId) {
      onBrandChange();
    }
  }, [brandId, prevBrandId, router, onBrandChange]);
}
